import gql from 'graphql-tag'

export const formQuery = gql`
  query form ($handle: [String], $site: [String]) {
    form: formieForm(handle: $handle, site: $site) {
      submissionMutationName
      settings {
        integrations {
          handle
          settings
          enabled
        }
      }
      pages {
        ... on PageType {
          settings {
            submitButtonLabel
            buttonsPosition
          }
        }
      }
      rows {
        id
        fields: rowFields {
          id
          required
          name: handle
          inputTypeName
          label
          placeholder
          typeName
          errorMessage
          visibility
          ... on Field_FileUpload {
            limitFiles
          }
          ... on Field_Dropdown {
            id
            multi
            options {
              isDefault
              isOptgroup
              label
              value
            }
          }
          ... on Field_Phone {
            id
            countryEnabled
            countryOptions {
              label
              value
            }
          }
          ... on Field_Date {
            isDate
            isTime
            isDateTime
            # Formie azzera sempre il "required" del campo Date esterno: l'obbligatorieta'
            # vera sta nei sotto-campi, che vanno letti per allineare asterisco e validazione
            # a quello che il server applica davvero.
            subFields: fields {
              handle
              required
            }
          }
          ... on Field_Agree {
            id
            description: descriptionHtml
            value: checkedValue
          }
          # Field_Entries: fetches the linked Craft entries (e.g. storeLocatorCountries).
          # Builder.vue overrides these static entries with dynamic options from useStoreSelection
          # for store-locator handles (dealerCountry). For any other Field_Entries field, the
          # entries array is used directly to build the select options.
          ... on Field_Entries {
            id
            entries {
              id
              title
              status
            }
          }
        }
      }
    }
  }
`
